import React from 'react';
import { Terminal, Activity, AlertCircle, ChevronUp, X } from 'lucide-react';
import { motion } from 'framer-motion';
import { LogEntry } from './types';
const MOCK_LOGS: LogEntry[] = [{
  id: '1',
  timestamp: '10:42:03.102',
  message: 'Gmail Trigger → 3 new emails detected',
  severity: 'info',
  category: 'Trigger'
}, {
  id: '2',
  timestamp: '10:42:04.450',
  message: 'Claude AI → summarising email_id: msg_1a2b3c...',
  severity: 'info',
  category: 'AI Action'
}, {
  id: '3',
  timestamp: '10:42:06.891',
  message: 'Filter → 1 marked urgent (score: 0.92)',
  severity: 'warning',
  category: 'Logic'
}, {
  id: '4',
  timestamp: '10:42:07.210',
  message: 'Draft Reply → generated response draft',
  severity: 'info',
  category: 'Action'
}, {
  id: '5',
  timestamp: '10:42:08.055',
  message: 'Send → delivered successfully ✓',
  severity: 'success',
  category: 'Action'
}];
const SeverityColors = {
  info: 'bg-sky-500',
  success: 'bg-emerald-500',
  warning: 'bg-amber-500',
  error: 'bg-rose-500'
};
export function BottomPanel() {
  return <div className="h-[180px] w-full bg-[#070b14] border-t border-slate-800/60 flex flex-col shrink-0 z-20 relative" data-id="element-7">
      {/* Tabs / Header */}
      <div className="flex items-center justify-between px-4 h-10 border-b border-slate-800/60 bg-[#0b101d]" data-id="element-8">
        <div className="flex items-center gap-6 h-full" data-id="element-9">
          <button className="h-full flex items-center gap-2 text-sm font-medium text-sky-400 border-b-2 border-sky-400 px-1" data-id="element-10">
            <Terminal className="w-4 h-4" data-id="element-11" />
            Live Logs
          </button>
          <button className="h-full flex items-center gap-2 text-sm font-medium text-slate-500 hover:text-slate-300 px-1 transition-colors" data-id="element-12">
            <Activity className="w-4 h-4" data-id="element-13" />
            Metrics
          </button>
          <button className="h-full flex items-center gap-2 text-sm font-medium text-slate-500 hover:text-slate-300 px-1 transition-colors" data-id="element-14">
            <AlertCircle className="w-4 h-4" data-id="element-15" />
            Errors{' '}
            <span className="bg-slate-800 text-slate-400 text-[10px] px-1.5 py-0.5 rounded-full ml-1" data-id="element-16">
              0
            </span>
          </button>
        </div>
        <div className="flex items-center gap-2" data-id="element-17">
          <button className="p-1 text-slate-500 hover:text-slate-300 transition-colors" data-id="element-18">
            <ChevronUp className="w-4 h-4" data-id="element-19" />
          </button>
          <button className="p-1 text-slate-500 hover:text-slate-300 transition-colors" data-id="element-20">
            <X className="w-4 h-4" data-id="element-21" />
          </button>
        </div>
      </div>

      {/* Log Stream */}
      <div className="flex-1 overflow-y-auto p-2 font-mono text-[13px] bg-[#070b14] space-y-1" data-id="element-22">
        {MOCK_LOGS.map((log, index) => <motion.div key={log.id} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.15,
        duration: 0.3
      }} className="flex items-start gap-3 px-3 py-1.5 hover:bg-slate-800/30 rounded transition-colors group" data-id="element-23">
            <div className="flex items-center gap-2 mt-0.5 shrink-0" data-id="element-24">
              <div className={`w-2 h-2 rounded-full ${SeverityColors[log.severity]} ${log.severity === 'success' ? 'glow-emerald' : ''}`} data-id="element-25" />
              <span className="text-slate-500 w-24" data-id="element-26">{log.timestamp}</span>
            </div>
            <div className="flex items-center gap-2 shrink-0" data-id="element-27">
              <span className="text-[10px] uppercase tracking-wider text-slate-400 bg-slate-800/50 px-1.5 py-0.5 rounded border border-slate-700/50" data-id="element-28">
                {log.category}
              </span>
            </div>
            <span className={`text-slate-300 ${log.severity === 'success' ? 'text-emerald-400' : ''} ${log.severity === 'warning' ? 'text-amber-400' : ''}`} data-id="element-29">
              {log.message}
            </span>
          </motion.div>)}
        {/* Blinking cursor effect */}
        <div className="px-3 py-1.5 flex items-center gap-2" data-id="element-30">
          <div className="w-2 h-4 bg-slate-600 animate-pulse" data-id="element-31" />
        </div>
      </div>
    </div>;
}